import * as echarts from "echarts"
import { ECBasicOption } from "echarts/types/dist/shared"
import { OptionDataValue } from "echarts/types/src/util/types"
import { UIView } from "uicore-ts"


export type EChartsTooltipValue = OptionDataValue | OptionDataValue[]

export interface EChartsShowTooltipEvent {
    type: "showtip"
    dataIndexInside: number
    dataIndex: number
    seriesIndex: number
    from: string
}

export type EChartsTooltipValueFormatter = (
    value: EChartsTooltipValue,
    showTooltipEvent: EChartsShowTooltipEvent
) => EChartsTooltipValue


export class EChartsView extends UIView {

    chartContentInset = 0

    chart = echarts.init(this.viewHTMLElement, null, {
        renderer: "svg", // canvas rendering mode
        devicePixelRatio: window.devicePixelRatio || 1,
        width: 1,
        height: 1,
        // @ts-ignore
        pointerCapture: false
    })

    private _showTooltipEvent?: {
        type: "showtip";
        dataIndexInside: number;
        dataIndex: number;
        seriesIndex: number;
        from: string
    }
    
    constructor(elementID?: string) {
        
        super(elementID)
        
        // Code for further setup if necessary
        
        // noinspection JSConstantReassignment
        this.controlEventTargetAccumulator.PointerUp = (sender, event) => {
            
            this.chart.getZr().handler.dispatch('mouseup', event);
            
        }
        
        this.viewHTMLElement.addEventListener("wheel", (event: WheelEvent) => {
            window.scrollBy({ top: event.deltaY, left: event.deltaX, behavior: "instant" })
        }, { passive: true, capture: true })
        
        // This hack is needed because echarts adds the tooltip into the canvas element, which does not work.
        this.chart.on(
            "showTip",
            (event: {
                type: "showtip",
                dataIndexInside: number,
                dataIndex: number,
                seriesIndex: number,
                from: string
            }) => {
                
                this._showTooltipEvent = event
                
                const tooltipEl = document.querySelector(".EChartsView_chart_tooltip") as HTMLElement
                if (tooltipEl && tooltipEl.parentElement != this.viewHTMLElement) {
                    this.viewHTMLElement.appendChild(tooltipEl)
                }
            }
        )
        
        
    }
    
    
    // Override this to format The value, do not use the built-in valueFormatter in the dataOptions as that is not good
    formatTooltipValue(value: EChartsTooltipValue, showTooltipEvent: EChartsShowTooltipEvent): EChartsTooltipValue {
        
        // noinspection BadExpressionStatementJS
        showTooltipEvent
        
        return value
        
    }
    
    
    set dataAndConfiguration(dataOptions: ECBasicOption | { tooltip: { cb_valueFormatter: EChartsTooltipValueFormatter } } ) {
        
        
        dataOptions = ({
            tooltip: {
                trigger: "item",
                appendToBody: false,
                transitionDuration: 0,
                className: "EChartsView_chart_tooltip",
                valueFormatter: (
                    value: OptionDataValue | OptionDataValue[],
                    dataIndex: number
                ) => {
                    
                    // @ts-ignore
                    const formatted = (dataOptions?.tooltip?.cb_valueFormatter ?? this.formatTooltipValue)(value, this._showTooltipEvent!)
                    return String(formatted ?? "")
                    
                }
            }
        } satisfies ECBasicOption).objectByCopyingValuesRecursivelyFromObject(dataOptions)
        
        this.chart.setOption(dataOptions)
        
    }
    
    get dataAndConfiguration() {
        return this.chart.getOption()
    }
    
    
    override layoutSubviews() {
        
        super.layoutSubviews()
        
        const bounds = this.bounds.rectangleWithInset(this.chartContentInset)
        
        this.chart.resize({ height: bounds.height, width: bounds.width })
        
        
    }
    
    
}




























